"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var KsysRequest_1 = require("../KsysRequest");
var ListTranslations = /** @class */ (function (_super) {
    __extends(ListTranslations, _super);
    function ListTranslations() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getExplicitEndpoint = function () { return '/config/listtranslations'; };
        return _this;
    }
    Object.defineProperty(ListTranslations.prototype, "endpointConfiguration", {
        get: function () {
            return this.getEndpointConfiguration("config", "ListTranslations");
        },
        enumerable: true,
        configurable: true
    });
    return ListTranslations;
}(KsysRequest_1.KsysRequest));
exports.ListTranslations = ListTranslations;
//# sourceMappingURL=ListTranslations.js.map